import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { t } from 'i18next';

import { initialPeriodsTableRow, IPeriodsTableRow } from 'components/BusinessToolForm/constants/periods';

export const OPERATING_ASSETS_AND_LIABILITIES_NAMES = {
  INCREASE_DECREASE_ACCOUNTS_RECEIVABLE: 'increaseDecreaseAccountsReceivable',
  INCREASE_DECREASE_INVENTORIES: 'increaseDecreaseInventories',
  INCREASE_DECREASE_ACCOUNTS_PAYABLE: 'increaseDecreaseAccountsPayable',
  INCREASE_DECREASE_OTHER_OPERATING_ASSETS_LIABILITIES: 'increaseDecreaseOtherOperatingAssetsLiabilities',
} as const;

export const useGetOperatingAssetsAndLiabilitiesLinkedFields = (isExamplePage: boolean) => {
  const { t, i18n } = useTranslation();
  return useMemo(() => {
    const operatingAssetsAndLiabilitiesLinkedFields = {
      [OPERATING_ASSETS_AND_LIABILITIES_NAMES.INCREASE_DECREASE_ACCOUNTS_RECEIVABLE]: {
        name: '',
        title:isExamplePage ? 'Increase/Decrease in accounts receivable' : t(
          'financialPlan.projectedCashFlow.inDirect.operatingAssetsAndLiabilities.increaseDecreaseAccountsReceivable',
        ),
      },
      [OPERATING_ASSETS_AND_LIABILITIES_NAMES.INCREASE_DECREASE_INVENTORIES]: {
        name: '',
        title: isExamplePage ? 'Increase/Decrease in inventories' : t('financialPlan.projectedCashFlow.inDirect.operatingAssetsAndLiabilities.increaseDecreaseInventories'),
      },
      [OPERATING_ASSETS_AND_LIABILITIES_NAMES.INCREASE_DECREASE_ACCOUNTS_PAYABLE]: {
        name: '',
        title: isExamplePage ? 'Increase/Decrease in accounts payable' : t(
          'financialPlan.projectedCashFlow.inDirect.operatingAssetsAndLiabilities.increaseDecreaseAccountsPayable',
        ),
      },
      [OPERATING_ASSETS_AND_LIABILITIES_NAMES.INCREASE_DECREASE_OTHER_OPERATING_ASSETS_LIABILITIES]: {
        name: '',
        title: isExamplePage ? 'Increase/Decrease in other operating assets and liabilities' : t(
          'financialPlan.projectedCashFlow.inDirect.operatingAssetsAndLiabilities.increaseDecreaseOtherOperatingAssetsLiabilities',
        ),
      },
    } as const;
    return operatingAssetsAndLiabilitiesLinkedFields;
  }, [t, i18n, isExamplePage]);
};

export const operatingAssetsAndLiabilitiesLinkedFields = {
  [OPERATING_ASSETS_AND_LIABILITIES_NAMES.INCREASE_DECREASE_ACCOUNTS_RECEIVABLE]: {
    name: '',
    title: t(
      'financialPlan.projectedCashFlow.inDirect.operatingAssetsAndLiabilities.increaseDecreaseAccountsReceivable',
    ),
  },
  [OPERATING_ASSETS_AND_LIABILITIES_NAMES.INCREASE_DECREASE_INVENTORIES]: {
    name: '',
    title: t('financialPlan.projectedCashFlow.inDirect.operatingAssetsAndLiabilities.increaseDecreaseInventories'),
  },
  [OPERATING_ASSETS_AND_LIABILITIES_NAMES.INCREASE_DECREASE_ACCOUNTS_PAYABLE]: {
    name: '',
    title: t('financialPlan.projectedCashFlow.inDirect.operatingAssetsAndLiabilities.increaseDecreaseAccountsPayable'),
  },
  [OPERATING_ASSETS_AND_LIABILITIES_NAMES.INCREASE_DECREASE_OTHER_OPERATING_ASSETS_LIABILITIES]: {
    name: '',
    title: t(
      'financialPlan.projectedCashFlow.inDirect.operatingAssetsAndLiabilities.increaseDecreaseOtherOperatingAssetsLiabilities',
    ),
  },
};

export interface IOperatingAssetsAndLiabilitiesInitialValues {
  [OPERATING_ASSETS_AND_LIABILITIES_NAMES.INCREASE_DECREASE_ACCOUNTS_PAYABLE]: IPeriodsTableRow;
  [OPERATING_ASSETS_AND_LIABILITIES_NAMES.INCREASE_DECREASE_INVENTORIES]: IPeriodsTableRow;
  [OPERATING_ASSETS_AND_LIABILITIES_NAMES.INCREASE_DECREASE_ACCOUNTS_RECEIVABLE]: IPeriodsTableRow;
  [OPERATING_ASSETS_AND_LIABILITIES_NAMES.INCREASE_DECREASE_OTHER_OPERATING_ASSETS_LIABILITIES]: IPeriodsTableRow;
}

export const operatingAssetsAndLiabilitiesInitialValues: IOperatingAssetsAndLiabilitiesInitialValues = {
  [OPERATING_ASSETS_AND_LIABILITIES_NAMES.INCREASE_DECREASE_ACCOUNTS_PAYABLE]: initialPeriodsTableRow,
  [OPERATING_ASSETS_AND_LIABILITIES_NAMES.INCREASE_DECREASE_INVENTORIES]: initialPeriodsTableRow,
  [OPERATING_ASSETS_AND_LIABILITIES_NAMES.INCREASE_DECREASE_ACCOUNTS_RECEIVABLE]: initialPeriodsTableRow,
  [OPERATING_ASSETS_AND_LIABILITIES_NAMES.INCREASE_DECREASE_OTHER_OPERATING_ASSETS_LIABILITIES]: initialPeriodsTableRow,
};
